import React from 'react';
export function CredibilitySection() {
  return <section className="py-16 md:py-24 px-4 bg-cream-dark" data-id="element-178">
      <div className="max-w-5xl mx-auto" data-id="element-179">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-180">
          {/* Left: Avatar */}
          <div className="lg:col-span-4 flex justify-center lg:justify-end" data-id="element-181">
            <div className="w-48 h-48 md:w-64 md:h-64 rounded-full border-4 border-cream shadow-xl relative overflow-hidden" data-id="element-182">
              <img src="https://cdn.magicpatterns.com/uploads/3q5yK4eftkLzbXGLooqweH/Roderic_Busto.png" alt="Roderic Guillen" className="w-full h-full object-cover" data-id="element-183" />
              {/* Decorative ring */}
              <div className="absolute inset-[-12px] border border-gold/30 rounded-full" data-id="element-184"></div>
            </div>
          </div>

          {/* Right: Story */}
          <div className="lg:col-span-8" data-id="element-185">
            <span className="inline-block text-cta font-bold tracking-widest text-sm uppercase mb-4" data-id="element-186">
              LA HISTORIA DETRÁS
            </span>

            <h2 className="text-2xl md:text-3xl font-serif font-bold text-navy leading-tight mb-2" data-id="element-187">
              "Desperté de una cirugía de seis bypass coronarios con más
              preguntas que certezas."
            </h2>

            <p className="text-navy/60 font-sans text-sm uppercase tracking-wider mb-8" data-id="element-188">
              Roderic Guillen · Sobreviviente
            </p>

            <div className="space-y-5 text-navy/80 font-sans text-lg leading-relaxed mb-8" data-id="element-189">
              <p data-id="element-190">
                Los profesionales de salud hicieron su trabajo. Lo hicieron
                bien. Pero el sistema tiene un límite conocido: el tiempo. Y en
                quince minutos de consulta no caben las preguntas que uno
                acumula.
              </p>
              <p data-id="element-191">
                Así comenzó un camino de años de investigación — revisando
                estudios científicos, literatura especializada — para entender
                lo que pasa dentro del cuerpo humano cuando el azúcar actúa en
                silencio.
              </p>
            </div>

            <blockquote className="border-l-4 border-gold pl-6 py-2 mb-8 bg-cream p-4 rounded-r-lg" data-id="element-192">
              <p className="text-xl font-serif italic text-navy" data-id="element-193">
                "No escribí este libro porque sé todo. Lo escribí porque aprendí
                a preguntar mejor — y ese camino me llevó años. A ti te puede
                tomar una tarde."
              </p>
            </blockquote>

            <div className="border-t border-navy/10 pt-4" data-id="element-194">
              <p className="text-xs md:text-sm text-navy/50 font-sans uppercase tracking-wider" data-id="element-195">
                Basado en investigación de: Nature · Diabetes Care · Journal of
                the American Dietetic Association · Clinical Nutrition
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}